// Traduz códigos de erro do Firebase Auth para mensagens que podem ser mostradas ao
// usuário final, sem vazar detalhes internos do provedor de autenticação.
const MESSAGES = Object.freeze({
  'auth/invalid-email': 'E-mail inválido.',
  'auth/user-disabled': 'Usuário desativado. Procure a gestão da escola.',
  'auth/user-not-found': 'Usuário ou senha inválidos.',
  'auth/wrong-password': 'Usuário ou senha inválidos.',
  'auth/invalid-credential': 'Usuário ou senha inválidos.',
  'auth/missing-password': 'Informe a senha.',
  'auth/too-many-requests': 'Muitas tentativas seguidas. Aguarde alguns minutos antes de tentar novamente.',
  'auth/network-request-failed': 'Falha de conexão. Verifique a internet e tente novamente.',
});

export function mapFirebaseAuthError(error) {
  const code = error?.code || '';
  return MESSAGES[code] || 'Não foi possível entrar. Tente novamente em instantes.';
}
